import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRemove = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 9,
	viewBox: "0 0 8 9",
	fill: "#C4C4C4",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 1.65174,
		height: 10.0656,
		rx: .825868,
		transform: "matrix(-0.7392 -0.673485 -0.673485 0.7392 8 1.11243)"
	}), /* @__PURE__ */ _jsx("rect", {
		y: 1.11243,
		width: 1.65174,
		height: 10.0656,
		rx: .825868,
		transform: "rotate(-42.3366 0 1.11243)"
	})]
});
export default SvgRemove;
